import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const authModuleConfig: OAuthModuleConfig = {
    resourceServer: {
        allowedUrls: ['https://elocky.com/api'],
        sendAccessToken: true
    }
};